module.exports = {
  labels: {
    label_color: 'Column color',
  },
  button: {
    color_edit: 'Edit',
  },
};
